import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { firebaseDB } from '../../firebase-config';
import { Alert } from '@mui/material';
import { useAuth } from '../../contexts';
import { SearchCity, BtnFuture } from '../components';
import { WeatherStart } from '../weather-start/weather-start';
import { AdvicesCards, UserAdvicesCards } from '../advices';
import './home.scss';

export const Home = ({ temperature, cityValue, getCiti, errors, cityName }) => {
    const [userChildren, setUserChildren] = useState([]);
    const { user } = useAuth();
    const usersChildrenCollectionRef = user &&
        collection(firebaseDB, `usersChildren/${user.uid}/children`);

    useEffect(() => {
        const getUserChildren = async () => {
            const data = user && await getDocs(usersChildrenCollectionRef);
            setUserChildren(data.docs.map(doc => ({ ...doc.data(), id: doc.id })));
        };
        user && getUserChildren();
        // eslint-disable-next-line
    }, [user]);

    return (
        <div>
            <div className='search-next'>
                <SearchCity cityValue={cityValue} getCiti={getCiti} />
                <BtnFuture url={`/${cityName}`} text='5 днів' />
                <BtnFuture url={`/pollution-air`} text='Стан забруднення повітря' />
            </div>
            {errors &&
                <Alert severity='error' sx={{ maxWidth: 556, margin: '0 auto 16px auto' }}>
                    Введіть коректну назву міста
                </Alert>
            }
            <WeatherStart cityName={cityName} />
            {!userChildren.length ?
                <AdvicesCards temperature={temperature} /> :
                <UserAdvicesCards temperature={temperature} userChildren={userChildren} />}
            <Outlet />
        </div>
    )
}